import {ReactElement, ReactNode} from "react";
import Spinner from "../spinner/Spinner";
import "./panel.scss";
import clsx from "clsx";

type PanelPropsType = {
    cover?: boolean;
    className?: string;
    children: ReactNode;
    icon?: ReactElement;
    header?: string;
    loading?: boolean;
    errorMessage?: string;
}
const Panel = ({className, children, header, icon, loading = false, errorMessage, cover = false}: PanelPropsType) => {
    const combinedClassName = `panel ${className || ''}`.trim();


    return (
        <div className={combinedClassName}>
            {
                (header || icon) &&
                    <div className="panel-bar">
                        {icon && <span className="leading-icon">{icon}</span>}
                        {header && <h3>{header}</h3>}
                    </div>
            }
            <div className={clsx("content", cover && "cover")}>
                {
                    loading ? <Spinner /> : errorMessage ? errorMessage : children
                }
            </div>
        </div>
    )
}

export default Panel;